// extracted by mini-css-extract-plugin
export default {"userOptionsContainer":"UserOptionsHeader_userOptionsContainer__JESEr"};